const AOS = require('aos');
const $ = require('jquery');
// v1.2 - back to top button
// const _ = require('lodash');
// force compile

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');

window.jQuery = $;

window.mapsInited = false;

$(function () {
    initPopup();
    loadAOS();
    initSliders();
    initGoogleMapping();
    containerFix();
    submenuOffset();
    heroOffset();

    // handler for the resize window event
    $(window).on("resize", function () {
        containerFix();
    });
    // handler for the scroll window event
    $(window).on("scroll", function () {
        checkWindowScroll();
        uncoverElements();
        toggleBackToTop();
    });

    $("#back-to-top").on("click", function (e) {
        e.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, 600);
    });


    //post filter ajax call
    $('.cat-list_item').on('click', function() {
        $('.cat-list_item').removeClass('active');
        $(this).addClass('active');

        $.ajax({
            type: 'POST',
            url: '/wp/wp-admin/admin-ajax.php',
            dataType: 'html',
            data: {
                action: 'filter_posts',
                category: $(this).data('slug'),
            },
            success: function(res) {
                $('.post-tiles').html(res);
            }
        })
    });

    // Smooth scroll.
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href="#0"]')
        .on("click", function (event) {
            if (
                location.pathname.replace(/^\//, "") ==
                this.pathname.replace(/^\//, "") &&
                location.hostname == this.hostname
            ) {
                var target = $(this.hash);
                var offset = $("header").outerHeight();
                target = target.length
                    ? target
                    : $("[name=" + this.hash.slice(1) + "]");
                if (target.length) {
                    event.preventDefault();
                    $("html, body").animate(
                        {
                            scrollTop: target.offset().top - offset,
                        },
                        1000
                    );
                }
            }
        });

    // Burger click
    $("#burger").click(function () {
        open = !open;
        toggleMenu(open);
    });


    // Active class.
    $("header .nav [href]").each(function () {
        if (this.href == window.location.href) {
            $(this).addClass("active");
        }
    });



    // Submenu.
    $(".submenu-toggle").on("click", function () {
        var toggle = $(this);
        toggle.toggleClass("open");
        $(this).prev(".parent-item").toggleClass("open");
        var submenu = $(this).next(".submenu");
        submenu.children("ul").slideToggle("fast");
    });

    $.fn.isScrolledIntoView = function () {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();
        var elemTop = $(this).offset().top;
        return elemTop <= docViewBottom && elemTop >= docViewTop;
    };
});


/**
 * @description loads the AOS library after a set timeout
 */
let loadAOS = () => {
    /*setTimeout(() => {
      $("body").addClass("loaded");
      setTimeout(() => {
        AOS.init();
      }, 500);
    }, 1000);*/
};

function initPopup() {
    console.log(localStorage.getItem('popupShown'));
    if(!localStorage.getItem('popupShown')) {
        $('.popup-container').addClass('open');
        $('.popup-container').click((e) => {
            const target = $(e.target);
            if (target.hasClass('popup-container')) {
                target.addClass('close');
            }
            if (target.hasClass('close-btn')) {
                $('.popup-container').addClass('close');
            }
        })
        localStorage.setItem('popupShown', '1');
    }
}

/*jQuery('header').prepend("<div class='popup-container'>"+
    "<div class=\"popup\">"+
      "<div class=\"popup-content\">"+
        "<div class=\"close-btn\"></div>"+
        "<a href=\"https://star-power.co.uk/news/star-power-joins-up-with-star-platforms-for-brilliant-future/\">"+
          "<img src=\"https://star-power.co.uk/wp-content/themes/frogspar/images/popup.png\" alt=\"Powertek is rebranding to Star Power\" />"+
        "</a>"+
      "</div>"+
    "</div>"+
  "</div>"
)*/


/**
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
 */
let checkWindowScroll = () => {
    let scroll = $(window).scrollTop();
    if (scroll > 0) {
        $("header").addClass("scroll");
    } else {
        $("header").removeClass("scroll");
    }
};

/**
 * @description function for fixing floating elements or page width elements with content to the conventional bootstrap container sizes
 */
let containerFix = () => {
    if ($(".container-fix").length) {
        let containerWidths = {
            576: 540,
            768: 720,
            992: 960,
            1200: 1140,
            1440: 1380,
        };

        let windowWidth = $(window).width();
        let containerWidth = 0;
        // let containerWidth = $(".container").width() + 32;

        for (const [key, value] of Object.entries(containerWidths)) {
            if (windowWidth >= key) {
                containerWidth = value;
            }
        }

        if (containerWidth == 0) {
            console.error("containerWidth = 0 in Global.js on line: 213");
            return;
        } else {
            containerWidth += 32; // account for the padding on a bs container
        }

        // now calculate the padding for the offset on the content
        var padding = (windowWidth - containerWidth) / 2 + 16;

        if (windowWidth >= 992) {
            $(".container-fix").each(function () {
                if ($(this).hasClass("odd")) {
                    $(this).css("padding-right", padding + "px");
                } else if ($(this).hasClass("even")) {
                    $(this).css("padding-left", padding + "px");
                }
            });
        } else if (windowWidth >= 576 && windowWidth <= 991) {
            $(".container-fix").each(function () {
                $(this).css("padding-left", padding + "px");
                $(this).css("padding-right", padding + "px");
            });
        } else {
            $(".container-fix").each(function () {
                $(this).css("padding-left", "16px");
                $(this).css("padding-right", "16px");
            });
        }
    }
};


/**
 *  @description affix appropriately css positioned elements (ie position = fixed || absolute) below the header banner
 */
let submenuOffset = () => {
    let headerHeight = $("#header").outerHeight();
    let dropdown = $(".submenu");
    let scroll = $(document).scrollTop();
    let topstripHeight = 0;

    if (scroll == 0) {
        dropdown.css("top", headerHeight + "px");
    } else if (scroll < topstripHeight) {
        dropdown.css("top", scroll + headerHeight + "px");
    } else {
        dropdown.css("top", headerHeight + "px");
    }
};

/**
 * @description offset elements labeled with the offset hero class by the height of the header
 */
let heroOffset = () => {
    let hero = $(".offset-hero");
    let header = $("header");

    if (hero.length && header.length) {
        let height = $(header).outerHeight();
        $(hero).css("margin-top", `${height}px`);
    }
};

/**
 * @description shows/hides back to top button based on scroll position
 */
let toggleBackToTop = () => {
    if ($(window).scrollTop() > 300) {
        $("#back-to-top").addClass("visible");
    } else {
        $("#back-to-top").removeClass("visible");
    }
};

let uncoverElements = () => {
    $(".uncover").each(function () {
        if ($(this).isScrolledIntoView() === true) {
            $(this).addClass("show");
        }
    });
};

/**
 * @description initialise the slick sliders for the page
 */
let initSliders = () => {
    // generic slider example
    // go to - https://kenwheeler.github.io/slick/ - for documentation
    $(".slider").each(function () {
        const $slider = $(this);
        const slidesToShow = parseInt($slider.data("slides-to-show"), 10) || 3;
        const slidesToScroll = parseInt($slider.data("slides-to-scroll"), 10) || 2;

        $slider.slick({
            dots: false,
            prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left text-senary" style="margin-right:-.15rem"></i></button>',
            nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right text-senary" style="margin-left:-.15rem"></i></button>',
            arrows: true,
            autoplay: false,
            autoplaySpeed: 4000,
            slidesToScroll: 1,
            slidesToShow: 1,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        centerMode: false,
                        dots: true,
                        slidesToScroll,
                        slidesToShow,
                    }
                },
            ],
        });
    });

    // replace prev arrow icon after slick init
    $(".slider .slick-prev").html('<i class="fa-solid fa-chevron-left text-senary" style="margin-right:-.15rem"></i>');

    // slider arrow functionality
    // $('.slick-{arrow-name}.slick-prev').click(function () {
    //   $('.{carousel-name}').slick('slickPrev');
    // });
    // $('.slick-{arrow-name}.slick-next').click(function () {
    //   $('.{carousel-name}').slick('slickNext');
    // });
};

/**
 * @description handles opening and closing of the mobile menu on the site
 *
 * @param {*} open flag indicating whether or not the menu is in an open state
 */
var open = false;
let toggleMenu = (open) => {
    $("#burger").toggleClass("open", open);
    $("#navigation-mobile ul").toggleClass("open", open);
};

/**
 * @description centers the map on the current marker or in the center of all markers present
 *
 * @param {*} map the JSON map object being worked on
 */
let centerMap = (map) => {
    let bounds = new google.maps.LatLngBounds();
    $.each(map.markers, function (i, marker) {
        let latlng = new google.maps.LatLng(
            marker.position.lat(),
            marker.position.lng()
        );
        bounds.extend(latlng);
    });
    if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(map.markers[0].zoomLevel || 14);
    } else {
        map.fitBounds(bounds);
    }
};

/**
 * @description adds a new marker to the map being created
 *
 * @param {*} $marker the jQuery HTML marker to be added
 * @param {*} map the JSON map object to be operated on
 */
let addMarker = ($marker, map) => {
    let latlng = new google.maps.LatLng(
        $marker.attr("data-lat"),
        $marker.attr("data-lng")
    );
    let icon = {
        url: "" + $marker.attr("data-icon") + "",
        scaledSize: new google.maps.Size(48, 48),
    };
    let marker = new google.maps.Marker({
        icon: icon,
        map: map,
        position: latlng,
    });
    marker.zoomLevel = parseInt($marker.attr("data-zoom")) || null;
    console.log("added marker: ", map.markers.push(marker));
    if ($marker.html()) {
        let infowindow = new google.maps.InfoWindow({
            content: $marker.html(),
        });
        google.maps.event.addListener(marker, "click", function () {
            infowindow.open(map, marker);
        });
    }
    // const contentString =
    //   '<div id="content">' +
    //   '<div id="siteNotice">' +
    //   "</div>" +
    //   '<h1 id="firstHeading" class="firstHeading">' + '<?php echo the_sub_field('contact_details');?>' + '</h1>' +
    //   '<div id="bodyContent">' +
    //   "<p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>, is a large " +
    //   "sandstone rock formation in the southern part of the " +
    //   "Northern Territory, central Australia. It lies 335&#160;km (208&#160;mi) " +
    //   "south west of the nearest large town, Alice Springs; 450&#160;km " +
    //   "(280&#160;mi) by road. Kata Tjuta and Uluru are the two major " +
    //   "features of the Uluru - Kata Tjuta National Park. Uluru is " +
    //   "sacred to the Pitjantjatjara and Yankunytjatjara, the " +
    //   "Aboriginal people of the area. It has many springs, waterholes, " +
    //   "rock caves and ancient paintings. Uluru is listed as a World " +
    //   "Heritage Site.</p>" +
    //   '<p>Attribution: Uluru, <a href="https://en.wikipedia.org/w/index.php?title=Uluru&oldid=297882194">' +
    //   "https://en.wikipedia.org/w/index.php?title=Uluru</a> " +
    //   "(last visited June 22, 2009).</p>" +
    //   "</div>" +
    //   "</div>";

    // const infowindow = new google.maps.InfoWindow({
    //   content: contentString,
    // });

    marker.addListener("click", () => {
        $("infowindow").toggle({
            function(){$("infowindow").css({"display": "block"});},
        });
    });
};

/**
 * @description creates a new map at the location of the jQuery element passed in
 *
 * @param {*} $el the jQuery element to create a map aroudn
 */
let newMap = ($el) => {
    let $markers = $el.find(".marker");
    console.log($markers);
    let args = {
        center: new google.maps.LatLng(54.5, -2),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "color": "#878787"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f9f5ed"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#c9c9c9"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#aee0f4"
                    }
                ]
            }
        ],
        zoom: 6,
    };
    let map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function () {
        addMarker($(this), map);
    });
    centerMap(map);
    return map;
};

/**
 * @description convenience function for running all code required to generate a single (or multiple) maps on a page
 */
let initGoogleMapping = () => {
    if(!window.mapsInited) {
        console.log("initGoogleMapping", window.mapsInited);
        window.mapsInited = true;
        if (typeof google === "undefined" || typeof google.maps === "undefined") {
            return;
        }
        $(".map").each(function () {
            newMap($(this));
        });
    }
};


//window.initGoogleMapping = initGoogleMapping;